type Props = {
	text: string;
	name: string;
	position: string;
};

export const CustomQuote = ({text, name, position}: Props) => {
	return (
		<div className="rounded-lg bg-blue-50 p-6">
			<blockquote className="text-[22px] font-normal">«{text}»</blockquote>
			<cite className="mt-4 block text-sm font-normal text-gray-600">
				<strong>{name}</strong>, {position}
			</cite>
		</div>
	);
};
